/**
 * Global Bus Event emmiter
 */
import { EVENT_BUS } from '@bto-services/event-bus';

/**
 * Use this const to emit and listen for events globally
 */
export const EventBus = EVENT_BUS;
